import React from 'react';
import { t, tscope, jsx } from '@i18n';

export const ts = tscope('Documents.payslipContent', {
  t: jsx,
  months: <b>{t('Common.months', { count: 2 })}</b>,
});
